import request from '@/config/axios'

export type ExpressClientCode = 'kd_100' | 'kd_niao' | 'not_provide'

export interface ExpressClientConfigVO {
  source?: 'db' | 'yaml'
  client: ExpressClientCode
  kd100Customer?: string
  kd100Key?: string
  kdniaoBusinessId?: string
  kdniaoApiKey?: string
  kdniaoRequestType?: string
}

export const getExpressClientConfig = async () => {
  return await request.get<ExpressClientConfigVO>({ url: `/trade/express-client-config/get` })
}

export const saveExpressClientConfig = async (data: ExpressClientConfigVO) => {
  return await request.put({ url: `/trade/express-client-config/save`, data })
}
